import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addBetterInfoHealth } from "../../Adapters/ApiAdapter";
import ReactQuill from "react-quill";

const AddBetterInfoHealth = () => {
  const [formData, setFormData] = useState({
    title: "",
    heading: "",
    decription: "",
    content: "",
    date: "",
    source_page: "",
    status: "",
    img_path: null,
  });
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle file changes
  const handleFileChange = (e) => {
    setFormData({ ...formData, img_path: e.target.files[0] });
  };
  const handleQuillChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const infoData = new FormData();
    const stripHtml = (html) => html.replace(/<[^>]+>/g, "").trim();
    for (let key in formData) {
      if (key === "img_path" && formData[key]) {
        infoData.append(key, formData[key]); // Only append img_path if it's present
      } else if (key === "decription" || key === "content") {
        infoData.append(key, stripHtml(formData[key]));
      } else if (key !== "img_path") {
        infoData.append(key, formData[key]);
      }
    }

    try {
      const response = await addBetterInfoHealth(infoData);
      if (response && response.status === "true") {
        toast.success("Better Info Health added successfully!");
        setFormData({
          title: "",
          heading: "",
          decription: "",
          content: "",
          date: "",
          source_page: "",
          status: "",
          img_path: null,
        });
      } else {
        toast.error("Failed to add Better Info Health.");
      }
    } catch (error) {
      toast.error("An error occurred while adding Better Info Health.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Add Better Info Better Health
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          value={formData.title}
          onChange={handleInputChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Heading"
          name="heading"
          value={formData.heading}
          onChange={handleInputChange}
          required
        />

        <Typography variant="body1">
          Description <span>*</span>
        </Typography>
        <ReactQuill
          theme="snow"
          value={formData.decription}
          onChange={(value) => handleQuillChange("decription", value)}
          style={{ height: "200px", marginBottom: "50px" }}
        />

        <Typography variant="body1">
          Content <span>*</span>
        </Typography>
        <ReactQuill
          theme="snow"
          value={formData.content}
          onChange={(value) => handleQuillChange("content", value)}
          style={{ height: "200px", marginBottom: "50px" }}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Date"
          name="date"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={formData.date}
          onChange={handleInputChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Source Page"
          name="source_page"
          value={formData.source_page}
          onChange={handleInputChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Status"
          name="status"
          value={formData.status}
          onChange={handleInputChange}
          required
        />
        <Button
          variant="contained"
          component="label"
          style={{ marginTop: "16px" }}
        >
          Upload Image
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={handleFileChange}
          />
        </Button>
        {formData.img_path && (
          <Typography variant="body2" style={{ marginTop: "8px" }}>
            Selected File: {formData.img_path.name}
          </Typography>
        )}
        <br />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
          style={{ marginTop: "20px" }}
        >
          {loading ? <CircularProgress size={24} /> : "Add Info"}
        </Button>
      </form>
    </Box>
  );
};

export default AddBetterInfoHealth;
